import React from 'react';

// SVG Icon components as functions
const XIcon = ({ size = 18, className = "" }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    className={className}
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const CheckIcon = ({ size = 18, className = "" }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    className={className}
  >
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
);

const InfoIcon = ({ size = 18, className = "" }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    className={className}
  >
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </svg>
);

const Alert = ({ alert, onClose }) => {
  return (
    <div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50 w-auto max-w-xl">
      <div className={`p-4 rounded-lg shadow-lg flex items-center justify-between gap-4 ${
        alert.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
      }`}>

        <div className="flex items-center gap-2">
          {alert.type === 'success' ? 
            <CheckIcon className="ml-1" /> : 
            <InfoIcon className="ml-1" />
          }
          <span>{alert.message}</span>
        </div>

        <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
          <XIcon />
        </button>

      </div>
    </div>
  );
};

export default Alert;